import React from "react";

import svg from "../../assets/images/icons/error_message.svg";

export const ErrorIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Error"}
    />
);
